const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'projects',
        preventClearOnCancel: true,
        updateTabTitleForFieldCodes: {
            title: true
        },
        updateTabTitleTabContentLocator: '<< base_tabStrip_tabContent',
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_projects': true,
        },
    },

    methods: {
        onBeforeRender(storage){
            const {statusUpdatedAt} = (this.resourceData.data || {}).attributes || {}
            const statusFieldConfig = ((this.model.namedFields || {}).status || {}).config
            if(statusUpdatedAt && statusFieldConfig){
                statusFieldConfig.subLabel = storage.__('projects.properties.fields.status.subLabel', { ts: utils.moment(statusUpdatedAt).format('DD.MM.YYYY [um] HH:mm') })
            }
        }
    }
}